import React, { useEffect } from 'react';
import WrapperEntitySelector from '@modules/entitySelector/WrapperEntitySelector';
import { withTranslation } from 'react-i18next';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { IForm } from '@ts/ui-models';

interface IACLPrivilegeFormProps extends IForm {}

const ACLPrivilegeForm = (props: IACLPrivilegeFormProps) => {
  const { mode, values, onChange } = props;

  const isViewMode = mode === 'view';

  //#region Handlers
  const _handleChangeEntitySelector = (entity, fkField) => {
    onChange(fkField, entity?.getID());
  };
  //#endregion

  return (
    <>
      <WrapperEntitySelector
        label="Entity"
        value={values.entityId}
        onChangeEntity={v => _handleChangeEntitySelector(v, 'entityId')}
        searchComponent={generateSearchEntitySelector('entity')}
        required
        isReadOnly={isViewMode}
      />
      <WrapperEntitySelector
        label="Role"
        value={values.securityRole}
        onChangeEntity={v => _handleChangeEntitySelector(v, 'securityRoleId')}
        searchComponent={generateSearchEntitySelector('role')}
        required
        isReadOnly={isViewMode}
      />
      <WrapperEntitySelector
        label="Action"
        value={values.actionId}
        onChangeEntity={v => _handleChangeEntitySelector(v, 'actionId')}
        searchComponent={generateSearchEntitySelector('action')}
        required
        isReadOnly={isViewMode}
      />
    </>
  );
};

export default withTranslation()(ACLPrivilegeForm);
